import React from 'react';

import PropTypes from 'prop-types';

import { Checkbox } from '@/components/ui/checkbox';
import { CommandGroup, CommandItem } from '@/components/ui/command';

import { tagShape } from '../../../types';
import { TagSwatch } from '../../Tag';

const TagList = ({ onToggle, selectedIds, tags }) => (
  <CommandGroup>
    {tags.map((tag) => (
      <CommandItem key={tag.id} onSelect={() => onToggle(tag.id)} value={tag.name}>
        <Checkbox checked={selectedIds.includes(tag.id)} />
        <TagSwatch color={tag.color} />
        <span className="truncate">{tag.name}</span>
      </CommandItem>
    ))}
  </CommandGroup>
);

TagList.propTypes = {
  onToggle: PropTypes.func.isRequired,
  selectedIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  tags: PropTypes.arrayOf(tagShape).isRequired,
};

export default TagList;
